export default function generateRandomPassword(length = 12) {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const number = '0123456789';
  const special = '!@#$%^&*()_+-='; // đã thêm + _ -

  const all = upper + lower + number + special;

  let password = '';
  // Đảm bảo ít nhất 1 ký tự mỗi loại
  password += upper[Math.floor(Math.random() * upper.length)];
  password += lower[Math.floor(Math.random() * lower.length)];
  password += number[Math.floor(Math.random() * number.length)];
  password += special[Math.floor(Math.random() * special.length)];

  // Thêm random phần còn lại
  for (let i = 4; i < length; i++) {
    password += all[Math.floor(Math.random() * all.length)];
  }

  // Shuffle chuỗi để tránh predictable vị trí
  return password
    .split('')
    .sort(() => 0.5 - Math.random())
    .join('');
}
